// extracted by mini-css-extract-plugin
export default {"table":"OrderHistory_table__tW2L+","icons":"OrderHistory_icons__3kRGA","pending":"OrderHistory_pending__dUUmV","delivered":"OrderHistory_delivered__1CVoM"};